import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './sidebar.css'
import LanguageSelector from "../languageSelector/language-selector.js";
import { useTranslation } from 'react-i18next';
import axiosInstance from '../../utils/axiosInstance.jsx';
import { Button, Modal } from 'react-bootstrap';
import imgLLM from '../../Resources/3D_IMAGE_FILE_EXTENSION_LLM-512.png'
import imgSalesDashboard from '../../Resources/sales-dashboard.png'

const SideNavbar = ({ handleLogout, employeeId }) => {
    const { t } = useTranslation()
    const location = useLocation();
    const [activeTab, setActiveTab] = useState(() => {
        const savedTab = localStorage.getItem('activeTab');
        const validPaths = ['/', '/EmployeeOperations', '/manageProjects', '/ManageEmployees', '/ApprovalsPage', '/LeaveRequests', '/AttendanceRequests', '/ManageHolidays', '/Reports', '/llm-model', '/sales-dashboard'];
        return validPaths.includes(savedTab) ? savedTab : '/';
    });
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [companyId, setCompanyId] = useState();

    const validPaths = ['/', '/EmployeeOperations', '/manageProjects', '/ManageEmployees', '/ApprovalsPage', '/LeaveRequests', '/AttendanceRequests', '/ManageHolidays', '/Reports', '/llm-model', '/sales-dashboard'];

    useEffect(() => {
        fetchCompanyId();
    }, [employeeId]);

    useEffect(() => {
        const currentPath = location.pathname;
        const newActiveTab = validPaths.includes(currentPath) ? currentPath : '/';
        setActiveTab(newActiveTab);
        localStorage.setItem('activeTab', newActiveTab);
    }, [location.pathname]);

    const fetchCompanyId = async () => {
        try {
            const response = await axiosInstance.get(`/admin/companyIdByEmpId/${employeeId}`);
            const data = response.data;
            setCompanyId(data.companyId);
        } catch (error) {
            console.error('Error fetching company ID:', error.message);
        }
    };

    const handleClick = (link) => {
        setActiveTab(link);
        localStorage.setItem('activeTab', link);
    };


    const handleLogoutClick = () => {
        setShowConfirmation(true);
    };

    const confirmLogout = () => {
        setShowConfirmation(false);
        handleLogout();
    };

    const cancelLogout = () => {
        setShowConfirmation(false);
    };


    return (
        <div className='SideNavbar'>
            <div className='divide'>
                <div className='SideNavbar-logo'>
                    <Link to="/">
                        <svg xmlns="http://www.w3.org/2000/svg" className="logo" height="72.465" width="550.794" viewBox="-322.518 -240.067 550.794 72.465">
                            <path d="m-16.758-240.067 13.916 5.812s-2.5 5.238-3.666 8.676c-1.075 3.167-3.666 10.968-3.666 10.968s-7.36 8.749-11.168 23.9c-3.166 12.605-3.2 22.434-3.2 22.434l-5.848.015s-.784-16.392 3.382-36.364c2.808-13.463 10.25-35.441 10.25-35.441z"></path>
                            <path d="m-322.518-168.526v-44.556h17.843v15.038h16.86v-15.038h17.843v44.556h-17.842v-17.266h-16.86v17.266zm55.548 0 19.506-44.556h18.146l19.507 44.556h-17.768l-2.117-5.879h-17.767l-2.042 5.879zm28.429-31.127-5.52 15.965h11.266zm70.901 10.891-.681-10.149v-14.171h17.087v44.556h-16.709l-19.431-24.258.68 10.149v14.109h-17.087v-44.556h16.709zm52.471-11.637c-.302-1.547-1.285-2.476-2.57-3.032-1.285-.557-2.873-.805-4.612-.805-3.931 0-5.67.928-5.67 2.537 0 6.684 31.301 2.537 31.301 18.75 0 10.334-10.509 15.347-25.479 15.347-14.365 0-23.741-6.869-24.119-14.914h17.087c.378 1.609 1.437 2.785 2.949 3.527 1.436.743 3.327 1.114 5.065 1.114 4.461 0 7.41-1.176 7.41-3.28 0-6.745-31.302-2.104-31.302-19.122 0-9.468 9.98-14.233 23.59-14.233 15.121 0 22.001 6.312 23.287 14.109h-16.937zm20.003 31.873 19.507-44.556h18.146l19.507 44.556h-17.768l-2.117-5.879h-17.768l-2.042 5.879zm28.428-31.127-5.519 15.965h11.265zm88.477 31.127v-44.556h42.34v10.396h-24.496v8.106h19.507v10.396h-19.507v15.656h-17.844zm52.087 0v-44.556h17.844v34.159h24.497v10.396h-42.341zm47.401 0v-44.556h44.381v10.396h-26.537v6.374h22.455v10.396h-22.455v6.993h27.596v10.396h-45.44zm69.473 0h-20.036l19.279-23.145-17.39-21.411h20.036l7.712 11.386 7.788-11.386h20.035l-18.372 21.411 18.524 23.145h-20.036l-8.77-12.5zm-187.07-62.45s-13.028 14.514-19.332 29.139c-7.668 17.785-7.262 33.561-7.262 33.561l13.558-.013s.204-12.593 6.704-27.817c6.104-14.297 16.666-25.21 16.666-25.21z" fill="#d4021d"></path>
                        </svg>
                    </Link>
                </div>

                <div className='SideNavbar-buttons'>
                    <Link to="/">
                        <button onClick={() => handleClick('/')} className={activeTab === '/' ? 'clicked' : ''}>

                            <svg className='sideLogo' width="18" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" clipRule="evenodd" d="M1 6.6L7.85714 1L14.7143 6.6V15.4C14.7143 16.2837 14.0321 17 13.1905 17H2.52381C1.68223 17 1 16.2837 1 15.4V6.6Z" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M5.57187 17V9H10.1433V17" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <span className='sideText'>{t("sidenavDashboard")}</span>

                        </button>
                    </Link>

                    <Link to="/EmployeeOperations">
                        <button onClick={() => handleClick('/EmployeeOperations')} className={activeTab === '/EmployeeOperations' ? 'clicked' : ''}>

                            <svg className='sideLogo' width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M21 10.0036C21 14.9702 16.9706 19 12 19C7.02944 19 3 14.9702 3 10.0036C3 5.03696 7.02944 1 12 1C16.9706 1 21 5.03696 21 10.0036Z" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M19 9.9939L14 14.9939L10 11.9939" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>

                            <span className='sideText'>{t("sidenav_Loggedin_Employee")}</span>

                        </button>
                    </Link>


                    <Link to="/manageProjects">
                        <button onClick={() => handleClick('/manageProjects')} className={activeTab === '/manageProjects' ? 'clicked' : ''}>
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M4 4C4 3.44772 4.44772 3 5 3H9C9.55228 3 10 3.44772 10 4H14C14.5523 4 15 4.44772 15 5H19C19.5523 5 20 5.44772 20 6V18C20 18.5523 19.5523 19 19 19H5C4.44772 19 4 18.5523 4 18V4ZM5 5V18H19V6H15V5H10V6H5V5Z" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M8 10H16M8 14H16" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <span className='sideText'>{t("sidenav_manageProject")}</span>

                        </button>
                    </Link>

                    <Link to="/ManageEmployees">
                        <button onClick={() => handleClick('/ManageEmployees')} className={activeTab === '/ManageEmployees' ? 'clicked' : ''}>

                            <svg className='sideLogo' width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M12 2C14.7614 2 17 4.23858 17 7C17 9.76142 14.7614 12 12 12C9.23858 12 7 9.76142 7 7C7 4.23858 9.23858 2 12 2Z" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M14 10L20 10L20 16L14 16L14 10ZM4 10L10 10L10 16L4 16L4 10ZM4 10L12 4L20 10" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <span className='sideText'>{t("sidenav_manageEmployees")}</span>

                        </button>
                    </Link>

                    <Link to="/ApprovalsPage">
                        <button onClick={() => handleClick('/ApprovalsPage')} className={activeTab === '/ApprovalsPage' ? 'clicked' : ''}>

                            <svg className='sideLogo' width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18 3H6C4.89543 3 4 3.89543 4 5V19C4 20.1046 4.89543 21 6 21H18C19.1046 21 20 20.1046 20 19V5C20 3.89543 19.1046 3 18 3Z" stroke="#000000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M16 3V9H8V3" stroke="#000000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M16 14H8" stroke="#000000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M16 19H8" stroke="#000000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <span className='sideText'>{t("sidenav_Approvals")}</span>
                        </button>
                    </Link>


                    {/* <button onClick={handleClick}>
                        <Link to="/EmployeeStats">
                        <svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3.5 3.5H13.5V16.5H3.5V3.5Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M1 6C1 5.44772 1.44772 5 2 5C2.55228 5 3 5.44772 3 6C3 6.55228 2.55228 7 2 7C1.44772 7 1 6.55228 1 6Z" fill="black"/>
                            <path d="M6 6C6 5.44772 6.44772 5 7 5C7.55228 5 8 5.44772 8 6C8 6.55228 7.55228 7 7 7C6.44772 7 6 6.55228 6 6Z" fill="black"/>
                            <path d="M11 6C11 5.44772 11.4477 5 12 5C12.5523 5 13 5.44772 13 6C13 6.55228 12.5523 7 12 7C11.4477 7 11 6.55228 11 6Z" fill="black"/>
                        </svg>

                            <span>Employee Stats</span>
                        </Link>
                    </button> */}


                    <Link to="/LeaveRequests">
                        <button onClick={() => handleClick('/LeaveRequests')} className={activeTab === '/LeaveRequests' ? 'clicked' : ''}>

                            <svg className='sideLogo' width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.25 2.75H3.75C3.33579 2.75 3 3.08579 3 3.5V16.5C3 16.9142 3.33579 17.25 3.75 17.25H13.25C13.6642 17.25 14 16.9142 14 16.5V3.5C14 3.08579 13.6642 2.75 13.25 2.75Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M6.875 7.75H10.125" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M6.875 10.875H10.125" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M6.875 14H10.125" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>

                            <span className='sideText'>{t("sidenav_LeaveRequests")}</span>

                        </button>
                    </Link>


                    <Link to="/AttendanceRequests">
                        <button onClick={() => handleClick('/AttendanceRequests')} className={activeTab === '/AttendanceRequests' ? 'clicked' : ''}>

                            <svg className='sideLogo' xmlns="http://www.w3.org/2000/svg" fill="none" width="24" height="24" viewBox="0 0 24 24">
                                <path d="M21 7H3a1 1 0 00-1 1v8a1 1 0 001 1h18a1 1 0 001-1V8a1 1 0 00-1-1zM3 15V9h18v6z" />
                            </svg>

                            <span className='sideText'>{t("sidenav_attendanceRequests")}</span>

                        </button>
                    </Link>

                    <Link to="/ManageHolidays">
                        <button onClick={() => handleClick('/ManageHolidays')} className={activeTab === '/ManageHolidays' ? 'clicked' : ''}>

                            <svg className='manageHolidaysIcon' xmlns="http://www.w3.org/2000/svg" fill="none" width="24" height="24" viewBox="0 0 24 24">
                                <path d="M19 3h-1V1h-2v2H8V1H6v2H5C3.9 3 3 3.9 3 5v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zm0-13H5V5h1v1h2V5h8v1h2V5h1v1zM7 10h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2zM7 14h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2z" />
                            </svg>

                            <span className='sideText'>{t("sidenav_manageHolidays")}</span>

                        </button>
                    </Link>


                    <Link to="/Reports">
                        <button onClick={() => handleClick('/Reports')} className={activeTab === '/Reports' ? 'clicked' : ''}>

                            <svg className='sideLogo' width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 16.875C1 16.2672 1.24144 15.6843 1.67121 15.2546C2.10098 14.8248 2.68388 14.5833 3.29167 14.5833H15.6667" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M3.29167 0.833344H15.6667V19.1667H3.29167C2.68388 19.1667 2.10098 18.9252 1.67121 18.4955C1.24144 18.0657 1 17.4828 1 16.875V3.12501C1 2.51722 1.24144 1.93433 1.67121 1.50456C2.10098 1.07479 2.68388 0.833344 3.29167 0.833344V0.833344Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <span className='sideText'>{t("sideNav_attendanceReports")}</span>

                        </button>
                    </Link>

                    {employeeId === 14569 && ( // Only display if employeeId is 14569 and 14589
                        <>
                            <Link to="/llm-model">
                                <button onClick={() => handleClick('/llm-model')} className={activeTab === '/llm-model' ? 'clicked' : ''}>
                                    <img src={imgLLM} width={22} alt="" />
                                    <span className='sideText'>{t("LLM Model")}</span>
                                </button>
                            </Link>
                            <Link to="/sales-dashboard">
                                <button onClick={() => handleClick('/sales-dashboard')} className={activeTab === '/sales-dashboard' ? 'clicked' : ''}>
                                    <img src={imgSalesDashboard} width={22} alt="" />
                                    <span className='sideText'>{t("Sales Dashboard")}</span>
                                </button>
                            </Link>
                        </>
                    )}

                    {employeeId === 14589 && ( // Only display if employeeId is 14569 and 14589
                        <>
                            <Link to="/llm-model">
                                <button onClick={() => handleClick('/llm-model')} className={activeTab === '/llm-model' ? 'clicked' : ''}>
                                    <img src={imgLLM} width={22} alt="" />
                                    <span className='sideText'>{t("LLM Model")}</span>
                                </button>
                            </Link>
                        </>
                    )}


                </div>
            </div>
            <div className='side-navbar-lang-button'>
                {companyId === 2 && ( // Only display if companyId is 2
                    <>
                        English <LanguageSelector /> Portugal
                    </>
                )}
            </div>
            <div className='SideNavbar-accSettings'>
                <button onClick={handleLogoutClick} className="logout-button">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-gear" viewBox="0 0 16 16">
                        <path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492M5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0" />
                        <path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115z" />
                    </svg>
                    <span>{t("sidenav_logOut")}</span>
                </button>
            </div>
            {/* {showConfirmation && (
                <div className="confirmation-modal">
                    <div className="sidebar-modal-content modal-content">
                        <p>{t("sidenav_logoutAlert")}</p>
                        <div>
                            <button onClick={confirmLogout}>{t("sidenav_logoutYes")}</button>
                            <button onClick={cancelLogout}>{t("sidenav_logoutNo")}</button>
                        </div>
                    </div>
                </div>
            )} */}

            <Modal show={showConfirmation} onHide={cancelLogout} centered size='md'>
                <Modal.Header closeButton>
                    <Modal.Title><b>{t("sidenav_logOut")}</b></Modal.Title>
                </Modal.Header>
                <Modal.Body>{t("sidenav_logoutAlert")}</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={cancelLogout}>
                        {t("sidenav_logoutNo")}
                    </Button>
                    <Button variant="primary" onClick={confirmLogout}>
                        {t("sidenav_logoutYes")}
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>

    )
}

export default SideNavbar